import { Card, Modal, Space } from '@procurify/ui'

import { Tabs } from '@webapp/core/components/Tabs'
import { CreateLegalEntityFormPresenter } from '@webapp/platform/legal-entities/features/create-legal-entity'
import { EditLegalEntityFormPresenter } from '@webapp/platform/legal-entities/features/edit-legal-entity'
import { LegalEntityListPresenter } from '@webapp/platform/legal-entities/features/list-legal-entities/presenters/LegalEntityListPresenter'
import { useLegalEntityListFeatureSet } from './useLegalEntityListFeatureSet'

export const LegalEntityListFeatureSet = () => {
  const {
    state: {
      isActive,
      tabs,
      createModalStates,
      editModalStates,
      editingEntity,
      editModalTitle,
    },
    methods: {
      onAdd,
      closeCreateModal,
      handleCreateSuccess,
      onEdit,
      closeEditModal,
      handleEditSuccess,
      onSelect,
      onDeactivate,
      onActivate,
    },
  } = useLegalEntityListFeatureSet()

  return (
    <>
      <Tabs>
        {tabs.map((tab) => (
          <Tabs.TabLink key={tab.to} to={tab.to}>
            {tab.label}
          </Tabs.TabLink>
        ))}
      </Tabs>

      <Card>
        <Card.Content>
          <LegalEntityListPresenter
            isActive={isActive}
            onAdd={onAdd}
            onEdit={onEdit}
            onSelect={onSelect}
            onDeactivate={onDeactivate}
            onActivate={onActivate}
          />
        </Card.Content>
      </Card>

      <Modal {...createModalStates} onClose={closeCreateModal} maxWidth='sm'>
        <Modal.Card>
          <CreateLegalEntityFormPresenter
            onCancel={closeCreateModal}
            onSuccess={handleCreateSuccess}
          />
        </Modal.Card>
      </Modal>

      {/*
        The feature set owns the modal chrome (Header + Content) for edit; the
        presenter renders only the form. (Create keeps its header in the
        presenter because its title changes per wizard step.)
      */}
      <Modal {...editModalStates} onClose={closeEditModal} maxWidth='sm'>
        <Modal.Card>
          {editingEntity && (
            <>
              <Modal.Header onClose={closeEditModal}>
                {editModalTitle}
              </Modal.Header>
              <Modal.Content>
                <EditLegalEntityFormPresenter
                  entity={editingEntity}
                  onCancel={closeEditModal}
                  onSuccess={handleEditSuccess}
                />
              </Modal.Content>
            </>
          )}
        </Modal.Card>
      </Modal>

      <Space />
    </>
  )
}

LegalEntityListFeatureSet.displayName = 'LegalEntityListFeatureSet'
